<template>
    <div class="item" :class="'item_' + this.itemType">

        <contract-item
            :item="item"
            v-if="this.itemType === 'contract'"
        />
        <service-item
            :item="item"
            v-if="this.itemType === 'service'"
        />

    </div>
</template>

<script>
    import ContractItem from "./ContractItem";
    import ServiceItem from "./ServiceItem";

    export default {
        name: "Item",
        components: { ContractItem, ServiceItem },
        props: {
            item: {},
            itemType: {}
        }
    }
</script>